import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import {
  getInfluencerByIdBuilder,
  getInfluencerFeedBuilder,
  getInfluencersBuilder,
  influencerFeedActionsBuilder,
} from './builder';

const INIT_STATE = {
  influencer: null,
  getInfluencersInfo: {
    page: 1,
    data: [],
    maxReached: false,
    pending: false,
    fetchMorePending: false,
    selectedFilter: 'TRENDING',
  },
  getInfluencerFeedInfo: {
    data: [],
    nextCursor: null,
    hasMore: true,
    limit: 20,
    loaded: false,
    pending: false,
    fetchMorePending: false,
    influencerId: null,
  },
  gridView: true,
  scrollPosition: 0,
  openMediaPreview: false,
  pending: {
    getInfluencerById: false,
  },
};

export const influencerSlice = createSlice({
  name: 'influencer',
  initialState: INIT_STATE,
  reducers: {
    setScrollPosition: (state, { payload }) => {
      state.scrollPosition = payload;
    },
    setInfluencer: (state, { payload }) => {
      state.influencer = payload;
    },
    setSelectedFilter: (state, { payload }) => {
      state.getInfluencersInfo.selectedFilter = payload;
    },
    setGridView: (state, { payload }) => {
      state.gridView = payload;
    },
    setOpenMediaPreview: (state, { payload }) => {
      state.openMediaPreview = payload;
    },
  },
  extraReducers: builder => {
    getInfluencersBuilder(builder);
    getInfluencerByIdBuilder(builder);
    getInfluencerFeedBuilder(builder);
    influencerFeedActionsBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const { setInfluencer, setSelectedFilter, setGridView, setScrollPosition, setOpenMediaPreview } =
  influencerSlice.actions;

export const selectGetInfluencersInfo = state => state.influencerInfo.getInfluencersInfo;
export const selectGetInfluencerFeedInfo = state => state.influencerInfo.getInfluencerFeedInfo;
export const selectInfluencer = state => state.influencerInfo.influencer;
export const selectAuthActionsPending = state => state.influencerInfo.pending;
export const selectGridView = state => state.influencerInfo.gridView;
export const selectScrollPosition = state => state.influencerInfo.scrollPosition;
export const selectOpenMediaPreview = state => state.influencerInfo.openMediaPreview;

export default influencerSlice.reducer;
